import { useState, useEffect, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Forms } from "../../components/backgrounds/Forms";
import { Primary } from "../../components/buttons/Primary";
import { Steps, titles } from "../../components/buttons/Steps";
import {
  maritalStatusOptions,
  genderOptions,
  educationLevelOptions,
} from "../../utils/options_selects";
import { loadData } from "../../services/loadCitys";
import { WarningAlert } from "../../components/alerts/warningAlert";
import { ModalAgreeLocation } from "../../components/modals/agreeLocation";
import { removeAccents, removeSpecialCharsAndEmojis } from "../../utils/validacionesForms";
import { validateSessionAndJwtToken } from "../../utils/validateTokenSession";
import { capitalizeFirstLetter } from "../../utils/capitalize";
import { returnToSignin } from "../../utils/returnToSign";

export function FormulariounoPage() {
  const navigate = useNavigate();
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [viewalert, setViewalert] = useState(false);
  const [jsonPlaces, setJsonPlaces] = useState([]);
  const [citysSelect, setCitysSelect] = useState([]);
  const [openModalLocation, setOpenModalLocation] = useState(false);
  const [errorFieldFirstname, setErrorFieldFirstname] = useState("");
  const [errorFieldSecondName, setErrorFieldSecondName] = useState("");
  const [errorFieldFirstlastname, setErrorFieldFirstlastname] = useState("");
  const [errorFieldSecondlastname, setErrorFieldSecondlastname] = useState("");
  const [errorFieldMaritalStatus, setErrorFieldMaritalStatus] = useState("");
  const [errorFieldAge, setErrorFieldAge] = useState("");
  const [errorFieldGender, setErrorFieldGender] = useState("");
  const [errorFieldEducationLevel, setErrorFieldEducationLevel] = useState("");
  const [errorFieldDepAddress, setErrorFieldDepAddress] = useState("");
  const [errorFieldCityAddress, setErrorFieldCityAddress] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [formOne, setFormOne] = useState({
    firstname: "",
    secondname: "",
    firstlastname: "",
    secondlastname: "",
    maritalStatus: "",
    age: "",
    gender: "",
    educationLevel: "",
    depAddress: "",
    cityAddress: ""
  });

  const handleOpenAlert = (message, isOpen) => {
    setMessageAlert(message);
    setIsOpenAlert(isOpen);
    setViewalert(true);
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenAlert(false);
    return;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let valueParsed = "";
    let textCapitalize = "";
    setErrorFieldAge("");
    switch (name) {
      case "firstname":
        textCapitalize = capitalizeFirstLetter(value);
        valueParsed = removeAccents(textCapitalize);
        valueParsed = removeSpecialCharsAndEmojis(valueParsed);
        setErrorFieldFirstname("");
        break;
      case "secondname":
        textCapitalize = capitalizeFirstLetter(value);
        valueParsed = removeAccents(textCapitalize);
        valueParsed = removeSpecialCharsAndEmojis(valueParsed);
        break;
      case "firstlastname":
        textCapitalize = capitalizeFirstLetter(value);
        valueParsed = removeAccents(textCapitalize);
        valueParsed = removeSpecialCharsAndEmojis(valueParsed);
        setErrorFieldFirstlastname("");
        break;
      case "secondlastname":
        textCapitalize = capitalizeFirstLetter(value);
        valueParsed = removeAccents(textCapitalize);
        valueParsed = removeSpecialCharsAndEmojis(valueParsed);
        break;
      case "age":
        valueParsed = value;
        break;
      default:
        break;
    }
    setFormOne({ ...formOne, [name]: valueParsed });
  };

  const handleChangeSelect = (e) => {

    setErrorFieldMaritalStatus("");
    setErrorFieldGender("");
    setErrorFieldEducationLevel("");
    setErrorFieldDepAddress("");
    setErrorFieldCityAddress("");

    const { name, value } = e.target;
    setFormOne({ ...formOne, [name]: value });

    if (name === "depAddress") {
      handleFilterCity(value);
    }

  };

  const handleFilterCity = (dep) => {
    try {
      const citysFiltered = jsonPlaces.filter(
        (val) => val.departamento === dep
      );
      citysFiltered[0].ciudades.unshift("Seleccione una opción.");
      setCitysSelect(citysFiltered[0].ciudades);
      return;
    } catch (error) {
      return;
    }
  };

  const loadDepartaments = async () => {
    try {
      const data = await loadData();
      data.places.unshift({
        id: "00",
        departamento: "Seleccione una opción.",
        ciudades: [],
      });
      setJsonPlaces(data.places);
    } catch (error) {
      console.log(error);
    }
  };

  const validarDatosVacios = (e) => {

    handleClearStateAlert();
    setOpenModalLocation(false);
    let coords = localStorage.getItem("coords");

    if (formOne.firstname.length === 0) {
      setErrorFieldFirstname("Por favor completa el campo nombre");
      e.preventDefault();
    } else if (formOne.firstlastname.length === 0) {
      setErrorFieldFirstlastname("Por favor completa el campo apellido");
      e.preventDefault();
    } else if (
      formOne.maritalStatus === "Selecciona una opción." ||
      formOne.maritalStatus === "" ||
      formOne.maritalStatus === "Selecciona una opción."
    ) {
      console.log(formOne.maritalStatus)
      setErrorFieldMaritalStatus("Por favor selecciona tu estado civil");
      e.preventDefault();
    } else if (formOne.age === "") {
      setErrorFieldAge("Por favor ingresa tu edad");
      e.preventDefault();
    } else if (
      formOne.gender === "Selecciona una opción" ||
      formOne.gender === ""
    ) {
      setErrorFieldGender("Por favor selecciona tu género");
      e.preventDefault();
    } else if (
      formOne.educationLevel === "Selecciona una opción" ||
      formOne.educationLevel === ""
    ) {
      setErrorFieldEducationLevel("Por favor selecciona tu nivel educativo");
      e.preventDefault();
    } else if (
      formOne.depAddress === "Selecciona una opción" ||
      formOne.depAddress === ""
    ) {
      setErrorFieldDepAddress("Por favor selecciona un departamento");
      e.preventDefault();
    } else if (
      formOne.cityAddress === "Seleccione una opción" ||
      formOne.cityAddress === "" ||
      formOne.cityAddress === "Selecciona una opción"
    ) {
      setErrorFieldCityAddress("Por favor selecciona una ciudad");
      e.preventDefault();
    } else if (!coords) {
      console.log("No existen Coordenadas");
      localStorage.setItem(
        "coords",
        JSON.stringify({ lat: "10.937711", lon: "-74.7629661" })
      );
    }
  };

  const determineOpenModalLocation = async (e) => {
    const result = await navigator.permissions.query({ name: "geolocation" });
    if (result.state === "granted") {
      navigator.geolocation.getCurrentPosition((position, error) => {
        if (error) console.log("No se logró encontrar la posición del usuario");
        console.log(position.coords.latitude, position.coords.longitude);
        localStorage.setItem(
          "coords",
          JSON.stringify({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          })
        );
      });
    } else if (result.state === "denied") {
      setOpenModalLocation(true);
    } else if (result.state === "prompt") {
      setOpenModalLocation(true);
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadDepts = async () => {
      await loadDepartaments();
    };

    try {
      loadDepts().then(async () => {
        setIsLoading(false);
        determineOpenModalLocation();
      });
    } catch (error) {
      console.log(error);
    }

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          try {
            await loadDepts();
            setIsLoading(false);
            determineOpenModalLocation();
          } catch (error) {
            console.log(error);
          }
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });

  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <div className="bg-purpleLight">
          <Steps
            estado1="current"
            estado2="upcoming"
            estado3="upcoming"
            estado4="upcoming"
          />

          <Forms
            title={titles[0].name}
            description={"Cargando la información."}
            form={
              <form action="#" method="POST">
                <div className="shadow-lg overflow-hidden rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="my-8"></div>
                  </div>
                </div>
              </form>
            }
          />
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {viewalert ? (
        <>
          <WarningAlert
            isOpen={isOpenAlert}
            message={messsageAlert}
          ></WarningAlert>
        </>
      ) : (
        <></>
      )}

      {openModalLocation ? (
        <>
          <ModalAgreeLocation isOpen={openModalLocation}></ModalAgreeLocation>
        </>
      ) : (
        <></>
      )}

      <div className="bg-purpleLight">
        <Steps
          estado1="current"
          estado2="upcoming"
          estado3="upcoming"
          estado4="upcoming"
        />
        <Forms
          title={titles[0].name}
          form={
            <form action="#" method="POST" autocomplete="off">
              <div
                styles={{ zIndex: 1 }}
                className="shadow-lg overflow-hidden rounded-md"
              >
                <div className="px-4 py-5 bg-white sm:p-6">
                  <div className="grid grid-cols-8 gap-6">
                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="firstname"
                        className="block text-sm font-medium"
                      >
                        Primer nombre
                      </label>
                      <div>
                        <input
                          onChange={handleChange}
                          value={formOne.firstname}
                          type="text"
                          name="firstname"
                          id="firstname"
                          maxLength="40"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        />
                      </div>
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldFirstname}
                      </span>
                    </div>
                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="secondname"
                        className="block text-sm font-medium"
                      >
                        Segundo nombre (opcional)
                      </label>
                      <div>
                        <input
                          onChange={handleChange}
                          value={formOne.secondname}
                          type="text"
                          name="secondname"
                          id="secondname"
                          maxLength="40"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        />
                      </div>
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldSecondName}
                      </span>
                    </div>
                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="firstlastname"
                        className="block text-sm font-medium"
                      >
                        Primer apellido
                      </label>
                      <div>
                        <input
                          onChange={handleChange}
                          value={formOne.firstlastname}
                          type="text"
                          name="firstlastname"
                          id="firstlastname"
                          maxLength="40"
                          required
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        />
                      </div>
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldFirstlastname}
                      </span>
                    </div>
                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="secondlastname"
                        className="block text-sm font-medium"
                      >
                        Segundo apellido (opcional)
                      </label>
                      <div>
                        <input
                          onChange={handleChange}
                          value={formOne.secondlastname}
                          type="text"
                          name="secondlastname"
                          id="secondlastname"
                          maxLength="40"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        />
                      </div>
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldSecondlastname}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="maritalStatus"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Estado civil
                      </label>

                      {maritalStatusOptions && (
                        <select
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="maritalStatus"
                          name="maritalStatus"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {maritalStatusOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldMaritalStatus}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="age"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Edad
                      </label>
                      <input
                        onChange={handleChange}
                        value={formOne.age}
                        type="number"
                        name="age"
                        id="age"
                        className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                      />
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldAge}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="gender"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Género
                      </label>

                      {genderOptions && (
                        <select
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="gender"
                          name="gender"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {genderOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldGender}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="education"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Nivel educativo
                      </label>

                      {educationLevelOptions && (
                        <select
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="educationLevel"
                          name="educationLevel"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {educationLevelOptions.map((item, index) => (
                            <option key={index}>{item.label}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldEducationLevel}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="depAddress"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Departamento
                      </label>

                      {jsonPlaces && (
                        <select
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="depAddress"
                          name="depAddress"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {jsonPlaces.map((item, index) => (
                            <option key={index}>{item.departamento}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldDepAddress}
                      </span>
                    </div>

                    <div className="col-span-8 sm:col-span-4">
                      <label
                        htmlFor="cityAddress"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Ciudad de Residencia
                      </label>
                      {citysSelect && (
                        <select
                          onChange={(choice) => handleChangeSelect(choice)}
                          id="cityAddress"
                          name="cityAddress"
                          className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                        >
                          {citysSelect.map((item, index) => (
                            <option key={index}>{item}</option>
                          ))}
                        </select>
                      )}
                      <span
                        className="text-sm"
                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                      >
                        {errorFieldCityAddress}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex px-4 py-6 md:flex md:justify-end bg-white text-right sm:px-6">
                  <div className="flex text-base">
                    <span className="text-left pr-2 my-auto">
                      Revisa los datos antes de continuar.
                    </span>
                  </div>
                  <div className="md:w-56">
                    <Link
                      to="/formulariodos"
                      state={formOne}
                      onClick={(e) => {
                        validarDatosVacios(e);
                      }}
                    >
                      <Primary text="Continuar" />
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          }
        />
      </div>
    </Fragment>
  );
}
